import { GIT_TAG_VERSION, GIT_VERSION } from 'gatsby-env-variables';
import { useEffect } from 'react';

import { session } from 'utils/storage';

const useLayout = () => {
  useEffect(() => {
    if (typeof window.__VERSION__ === 'undefined') {
      window.__VERSION__ = GIT_VERSION;
    }

    if (typeof window.__TAG__ === 'undefined') {
      window.__TAG__ = GIT_TAG_VERSION;
    }

    const hasNotSourceUrl = !session.getItem('source-url');

    if (hasNotSourceUrl) {
      session.setItem('source-url', window.location.href);
    }
  }, []);
};

export default useLayout;
